
export default function CoFounderSection() {
  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20">
        <div className="flex flex-col lg:flex-row items-center gap-8 sm:gap-10 lg:gap-16">
          {/* Profile Image */}
          <div className="relative flex-shrink-0">
            <div className="w-32 h-32 sm:w-40 sm:h-40 lg:w-56 lg:h-56 rounded-full overflow-hidden border-4 border-teal-500 shadow-xl">
              <img
                src="https://static.readdy.ai/image/ff0b7e80ce034da2f0ffbed7fce4b50d/bd598bf1fc7c0c8542319a5db78f1ed3.jpeg"
                alt="Himanshu"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-2 -right-2 w-10 h-10 sm:w-12 sm:h-12 lg:w-16 lg:h-16 bg-teal-600 rounded-full flex items-center justify-center shadow-lg">
              <i className="ri-heart-pulse-line text-white text-lg sm:text-xl lg:text-2xl"></i>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
              Meet Himanshu
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed">
              With over 15 years of experience in healthcare technology, Himanshu brings deep expertise in building platforms that make complex medical information accessible and actionable. His passion for leveraging technology to improve healthcare outcomes drives Vazcular's innovative approach to genetic testing and personalized care.
            </p>

            {/* Quote Card */}
            <div className="bg-white p-4 sm:p-6 lg:p-8 rounded-xl sm:rounded-2xl shadow-lg border-l-4 border-teal-500">
              <div className="flex items-start gap-3 sm:gap-4">
                <i className="ri-double-quotes-l text-3xl sm:text-4xl lg:text-5xl text-teal-500 flex-shrink-0"></i>
                <div>
                  <p className="text-sm sm:text-base lg:text-lg text-gray-700 italic mb-3 sm:mb-4 leading-relaxed">
                    "Technology should empower people to take control of their health. At Vazcular, we're making genetic heart disease screening as simple and accessible as checking your email—because everyone deserves to know their risk and have the tools to protect their future."
                  </p>
                  <p className="text-xs sm:text-sm lg:text-base font-semibold text-gray-900">
                    — Himanshu, Co-Founder & CTO
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
